import { render } from "./DocumentReviewArtifact.vue?vue&type=template&id=c89f8536&scoped=true"
import script from "./DocumentReviewArtifact.vue?vue&type=script&lang=js"
export * from "./DocumentReviewArtifact.vue?vue&type=script&lang=js"

import "./DocumentReviewArtifact.vue?vue&type=style&index=0&id=c89f8536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89f8536"]])

export default __exports__